import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { ChoiceStyles, applyChoiceElemCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-radio',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxRadioStyleDirective {
  componentStyle = input<{
    style: ChoiceStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyChoiceElemCustomStyles(
        this.componentStyle().style,
        theme(),
        fonts(),
        'radio'
      )
      this.styleClassName.set(className)
    })
  }
}
